export const GET_MARKETMAN_SETUP_REQUESTED = 'brand/GET_MARKETMAN_SETUP_REQUESTED';
export const GET_MARKETMAN_SETUP_SUCCESS = 'brand/GET_MARKETMAN_SETUP_SUCCESS';
export const GET_MARKETMAN_SETUP_FAILURE = 'brand/GET_MARKETMAN_SETUP_FAILURE';

export const UPDATE_MARKETMAN_SETUP_REQUESTED = 'brand/UPDATE_MARKETMAN_SETUP_REQUESTED';
export const UPDATE_MARKETMAN_SETUP_SUCCESS = 'brand/UPDATE_MARKETMAN_SETUP_SUCCESS';
export const UPDATE_MARKETMAN_SETUP_FAILURE = 'brand/UPDATE_MARKETMAN_SETUP_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  marketmanList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_MARKETMAN_SETUP_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
        marketmanList: [],
      };
    }
    case GET_MARKETMAN_SETUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        marketmanList: action.result,
      };
    }
    case GET_MARKETMAN_SETUP_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        marketmanList: [],
      };
    }
    case UPDATE_MARKETMAN_SETUP_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case UPDATE_MARKETMAN_SETUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_MARKETMAN_SETUP_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getMarketmanConfig = (brandId) => {
  return {
    types: [GET_MARKETMAN_SETUP_REQUESTED, GET_MARKETMAN_SETUP_SUCCESS, GET_MARKETMAN_SETUP_FAILURE],
    promise: client => client.get(`getMarketmanConfig/${brandId}`)
  };
};

export const updateMarketmanConfig = (brandId, data) => {
  return {
    types: [UPDATE_MARKETMAN_SETUP_REQUESTED, UPDATE_MARKETMAN_SETUP_SUCCESS, UPDATE_MARKETMAN_SETUP_FAILURE],
    promise: client => client.post(`updateMarketmanConfig/${brandId}`, { data })
  };
};
